// Prices.jsx
'use client';
import Container from '@/components/@base/container';
import Switch from '@/components/@base/input/switch';
import { Text } from '@/components/@base/typography';
import { useGetCart } from '@/components/app/cart/services/hooks';
import PriceView from '@/components/shared/components/price-view';

import { useCheckoutStore } from '@/store/checkout.store';

import { pageLevelLocalization } from '@/constant/localization';

import { useFinalPrice } from '../hooks';

const { cart: cartLocalization } = pageLevelLocalization;

export default function Prices() {
  const { data, isLoading } = useGetCart();
  const { useWallet, setUseWallet } = useCheckoutStore();
  const finalPrice = useFinalPrice();

  return (
    <Container center className='w-full p-[10px] *:w-full md:px-0'>
      <Container className='max-w-[350px] rounded-md px-[5px] pt-7 shadow-[0px_5px_15px_0px_rgba(73,75,84,0.06)]'>
        <Container className='flex justify-between px-[15px] py-5'>
          <Text className='text-[15px] text-[#76767C]'>
            {cartLocalization.productsPrice} ({data?.products?.length || 0})
          </Text>
          <PriceView isLoading={isLoading} price={data?.total} priceClassName='text-[19px]' />
        </Container>

        {data?.subtotal !== 0 && (
          <Container className='flex justify-between px-[15px] pb-5'>
            <Text className='text-[15px] text-[#76767C]'>
              {cartLocalization.productDiscount}
            </Text>
            <PriceView
              isLoading={isLoading}
              price={data?.subtotal}
              priceClassName='text-[19px]'
            />
          </Container>
        )}

        {!isLoading && data?.wallet?.total !== 0 && (
          <Container className='flex justify-between px-[15px] pb-5'>
            <Container className='flex items-center gap-2'>
              <Text className='text-[15px] text-[#76767C]'>{cartLocalization.wallet}</Text>
              <Switch checked={useWallet} onChange={(checked) => setUseWallet(checked)} />
            </Container>
            <PriceView
              isLoading={isLoading}
              price={data?.wallet?.total}
              priceClassName='text-[19px]'
            />
          </Container>
        )}
        <Container
          center
          className='bg-opacity-5 justify-between rounded-md bg-[linear-gradient(180deg,#84ba521f,rgba(132,186,82,0)_100%)] px-[15px] py-5'
        >
          <Text className='text-[15px] text-[#668933]' bold>
            {cartLocalization.checkoutAmount}
          </Text>

          <PriceView
            isLoading={isLoading}
            price={finalPrice}
            priceClassName='text-[19px] text-[#668933]'
          />
        </Container>
      </Container>
    </Container>
  );
}
